export const partFields = [
  "direct_material_costs_part",
  "material_overhead_costs_part",
  "interest_costs_on_material_stock_part",
  "material_scrap_costs_part",
  "material_costs_part",
  "work_system_costs_part",
  "labour_costs_part",
  "setup_costs_part",
  "tool_and_fixture_costs_part",
  "residual_manufacturing_overhead_costs_part",
  "interest_costs_of_circulating_stocks_part",
  "manufacturing_scrap_costs_part",
  "manufacturing_costs_part",
  "production_costs_part",
  "surcharges_part",
  "profit_part",
  "discount_part",
  "transport_costs_part",
  "customs_dutyies_part",
  "net_sales_price_part"
];

export const partSummaries = [
  "material_costs_part",
  "manufacturing_costs_part",
  "production_costs_part",
  "net_sales_price_part"
];
